"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Box = _interopRequireDefault(require("../Box"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _Typography = _interopRequireDefault(require("../Typography"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MessageBox(props) {
  if (!props.title && !props.body) return null;
  let colors = {
    bg: "yellow.main",
    text: "common.black"
  };
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    bg: colors.bg,
    p: "m",
    br: "m"
  }, /*#__PURE__*/_react.default.createElement(_Stack.default, {
    distribution: "center",
    direction: "vertical"
  }, props.title ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    ff: "mainBold",
    color: colors.text
  }, props.title) : null, props.body ? /*#__PURE__*/_react.default.createElement(_Typography.default, {
    color: colors.text
  }, props.body) : null));
}

MessageBox.defaultProps = {
  type: "warning"
};
var _default = MessageBox;
exports.default = _default;